<ion-header>
  <ion-toolbar>
    <ion-title class="ion-text-center">{{'reset-password-page.reset-password' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button router-direction="root" routerLink="/login">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <logo></logo>
  <form *ngIf="resetPasswordFormGroup" [formGroup]="resetPasswordFormGroup">
    <ion-item class="input-field">
      <ion-input label-placement="stacked" data-cy="email" type="email" [formControl]="email" [label]="'reset-password-page.email' | translate"></ion-input>
    </ion-item>
    <ion-item>
      <ion-button size="medium" slot="end" [disabled]="!isValid()" data-cy="reset"
                  (click)="onResetPassword()">{{'reset-password-page.reset-password' | translate}}
      </ion-button>
    </ion-item>
  </form>
</ion-content>
